// removed by extract-text-webpack-plugin
module.exports = {"backdrop":"ModalTemplate__backdrop___2HMKK","dialog":"ModalTemplate__dialog___1sCp_","header":"ModalTemplate__header___3MuM8","close":"ModalTemplate__close___1Ku__"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/ModalTemplate.less
 ** module id = 767
 ** module chunks = 0
 **/